var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCurvedLines(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 292,
    height: 153,
    viewBox: "0 0 260 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M389.489 220.478C389.489 127.136 313.82 51.4668 220.478 51.4668C127.136 51.4668 51.4668 127.136 51.4668 220.478C51.4668 313.82 127.136 389.489 220.478 389.489C313.82 389.489 389.489 313.82 389.489 220.478ZM77.3059 220.478C77.3059 141.406 141.406 77.3059 220.478 77.3059C299.55 77.3059 363.65 141.406 363.65 220.478C363.65 299.55 299.55 363.65 220.478 363.65C141.406 363.65 77.3059 299.55 77.3059 220.478Z",
    fill: "#737373"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M339.378 220.024C339.378 154.105 285.94 100.668 220.022 100.668C154.104 100.668 100.667 154.105 100.667 220.024C100.667 285.942 154.104 339.379 220.022 339.379C285.94 339.379 339.378 285.942 339.378 220.024ZM126.528 220.024C126.528 168.388 168.387 126.53 220.022 126.53C271.657 126.53 313.516 168.388 313.516 220.024C313.516 271.659 271.657 313.517 220.022 313.517C168.387 313.517 126.528 271.659 126.528 220.024Z",
    fill: "#737373"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M438.689 219.568C438.689 98.5497 340.584 0.445312 219.567 0.445312C98.5487 0.445312 0.444336 98.5497 0.444336 219.568C0.444336 340.585 98.5487 438.69 219.567 438.69C340.584 438.69 438.689 340.585 438.689 219.568ZM26.3249 219.568C26.3249 112.843 112.842 26.3259 219.567 26.3259C326.291 26.3259 412.808 112.843 412.808 219.568C412.808 326.292 326.291 412.809 219.567 412.809C112.842 412.809 26.3249 326.292 26.3249 219.568Z",
    fill: "#737373"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurvedLines);
export default __webpack_public_path__ + "static/media/curved-lines.2fc4ccc74a20be337c55881407334203.svg";
export { ForwardRef as ReactComponent };